import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-number-control',
  templateUrl: './number-control.component.html',
  styleUrls: ['./number-control.component.scss'],
  standalone: false
})
export class NumberControlComponent {

  @Input() number: number = 0;
  @Output() numberChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() min?: number;
  @Input() max?: number;

  @Input() disabled: boolean = false;

  constructor() {}

  decrement() {
    if (this.disabled) {
      return;
    }

    this.number--;
    if (this.min && this.number < this.min) {
      this.number = this.min;
    }
    this.numberChange.emit(this.number);
  }

  increment() {
    if (this.disabled) {
      return;
    }

    this.number++;
    if (this.max && this.number > this.max) {
      this.number = this.max;
    }
    this.numberChange.emit(this.number);
  }
}
